export default "__VITE_ASSET__2f629e69__"